import Vue from 'vue';
import ToolBar from '../../parts/ToolBar.vue';
import { MUTATION_TYPES } from "../../../lib/mutationTypes";
export default Vue.extend({
    components: { ToolBar },
    name: "DonationDetail",
    props: {
        target: {
            type: String,
            default: ''
        }
    },
    computed: {
        targetName() {
            return this.$data[this.target].name;
        },
        targetIcon() {
            return this.$data[this.target].icon;
        },
        targetJob() {
            return this.$data[this.target].job;
        },
        targetDetail() {
            return this.$data[this.target].detail;
        },
        targetAddress() {
            return this.$data[this.target].address;
        },
        targetPublicKey() {
            return this.$data[this.target].publicKey;
        },
    },
    data() {
        return {
            android: {
                name: 'Android Developer',
                icon: 'icon_yuki.png',
                job: this.$t('common.engineer'),
                detail: this.$t('donation.android_developer_detail'),
                address: 'NBHF3BSD4OHRIXHIERML27LHABVKK2MVK36YOYUN',
                publicKey: 'b5ffa10aca9ac7abbf6517195d9a7eae2cdcb3b9f286ce11837d0d8ecc9669b2'
            },
            rhime: {
                name: 'Rhime',
                icon: 'icon_rhime.png',
                job: 'UI' + this.$t('common.designer'),
                detail: this.$t('donation.rhime_detail'),
                address: 'NA4JR3MMBGS2P5U6WD7WVKYE5IHJZYICDDUL3IQI',
                publicKey: '2d781927ab153e2fb4d23284ac3d63a46aa4acea4f01a34dd6856c5a28280bf5',
            },
            ryuta: {
                name: 'Ryuta',
                icon: 'icon_ryuta.png',
                job: 'iOS' + this.$t('common.engineer'),
                detail: this.$t('donation.ryuta_detail'),
                address: 'NAEZYI6YPR4YIRN4EAWSP3GEYU6ATIXKTXSVBEU5',
                publicKey: 'f687ee0fc27fa664f19c072825e0ccc8e0bf631b704434c977fa6472d7c4980f'
            }
        };
    },
    methods: {
        donate() {
            this.$store.commit(MUTATION_TYPES.SET_RECEIVER_ADDRESS, this.targetAddress);
            this.$store.commit(MUTATION_TYPES.SET_RECEIVER_PUBLIC_KEY, this.targetPublicKey);
            this.$store.commit(MUTATION_TYPES.CLEAR_SEND_MOSAIC);
            this.$router.push('/send/amount');
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/donation/DonationDetail.vue
// module id = 659
// module chunks = 1